/**
 * Swissdec 30/360 day count convention.
 * - Day 31 is normalized to 30
 * - Feb 28/29 (last day of Feb) is normalized to 30
 * - Weekends count
 *
 * This is a frontend duplicate for display purposes only.
 * The backend is authoritative for all calculations.
 */
function normalizeDay(year: number, month: number, day: number): number {
  if (day >= 31) return 30;
  // Last day of February → 30
  const lastDayOfFeb = new Date(year, 1 + 1, 0).getDate(); // Feb = month 1 (0-indexed)
  if (month === 2 && day >= lastDayOfFeb) return 30;
  return day;
}

export function countSwissdecDays(fromDate: string, toDate: string): number {
  const from = new Date(fromDate);
  const to = new Date(toDate);

  if (isNaN(from.getTime()) || isNaN(to.getTime())) return 0;
  if (to < from) return 0;

  const y1 = from.getFullYear(), m1 = from.getMonth() + 1, d1raw = from.getDate();
  const y2 = to.getFullYear(), m2 = to.getMonth() + 1, d2raw = to.getDate();

  const d1 = normalizeDay(y1, m1, d1raw);
  const d2 = normalizeDay(y2, m2, d2raw);

  return (y2 - y1) * 360 + (m2 - m1) * 30 + (d2 - d1) + 1;
}
